import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function getValidarCelularSMS(usuarioOK, cellphone, code) {
  const url = `${webservice}/getValidarCelularSMS?usuarioOK=${usuarioOK}&celular=${cellphone}&codigo=${code}&dominio=${window.location.hostname}`;
  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      const { body = {} } = res;
      response = body;
    })
    .catch((err) => {
      console.log(err);
      response = err;
    });

  return response;
}
